import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b8ca4ae2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hd-asset-bespoke" }
const _hoisted_2 = {
  key: 1,
  class: "hd-asset-bespoke__no-content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.activeComponent())
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.activeComponent()), { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, " No Bespoke Template found "))
  ]))
}